import { Link, useNavigate } from "react-router-dom";
import patient from "../../../../assets/img/patient.jpg";
import { useEffect, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import { ADMIN_CMS_TESTIMONIALS } from "../../../../action/apiPath";
import { CallWithAuth } from "../../../../action/apiActions";
import { showToast } from "../../../../util/toastHelper";
import arrorRight from "../../../../assets/img/arrow-right.svg";
import { ADMINCMSTESTIMONIALADD, ADMINCMSTESTIMONIALUPDATE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminTestimonialList = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [testimonialList, setTestimonialList] = useState([]);

    useEffect(() => {
        getTestimonialData();
    }, []);

    const getTestimonialData = async () => {
        setIsLoading(true);
        try {
            setIsLoading(true);
            const response = await CallWithAuth("GET", ADMIN_CMS_TESTIMONIALS);
            if (response.res.status == 200) {
                setTestimonialList(response?.res?.data?.data);
            } else {
                showToast("error", response.res.data.message);
            }
            setIsLoading(false);
        } catch (err) {
            const errorMessage = err?.response?.data?.message || err?.message || "Unexpected error occurred";
            showToast("error", errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        const result = await MySwal.fire({
            title: "Are you sure want to delete this testimonial?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });
        if (result.isConfirmed) {
            setIsLoading(true);
            try {
                const response = await CallWithAuth("DELETE", `${ADMIN_CMS_TESTIMONIALS}/${id}`);
                if (
                    response?.res?.data?.statusCode === 200 ||
                    response?.res?.data?.statusCode === 201
                ) {
                    showToast("success", "Testimonial has been deleted successfully");
                    getTestimonialData();
                } else {
                    showToast("error", response?.res?.data?.message);
                }
            } catch (error) {
                showToast("error", "Something went wrong while deleting testimonial.");
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {isLoading && (
                <>
                    <Loading
                        loading
                        background="rgba(236, 240, 241, 0.7)"
                        loaderColor="#3498db"
                    />
                </>
            )}
            <div>
                <section className="site_hero patient_management_banner">
                    <div className="site_container">
                        <div className="site_row">
                            <div className="txt_colm">
                                <div className="txt_block">
                                    <h1>Manage Testimonials</h1>
                                    <p>Manage each Testimonials efficiently</p>
                                    <div className="btn_row">
                                        <Link
                                            to={`${ADMINCMSTESTIMONIALADD}`}
                                            className="solid_cta cta_primary cta_with_icon"
                                        >
                                            <span>Add Testimonial</span> <img src={arrorRight} alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="img_colm">
                                <div className="img_block">
                                    <img src={patient} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="site_container">
                    <div className="patient_form_block bg_light_gray my-4">
                        <div className="table-responsive">
                            <table className="table patient-row-details m-0">
                                <thead>
                                    <tr>
                                        <th width="15%">Name</th>
                                        <th width="15%">Designation</th>
                                        <th width="30%">Quote</th>
                                        <th width="5%">Image</th>
                                        <th width="10%" className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {testimonialList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.author_name}</td>
                                            <td>{item.author_title}</td>
                                            <td>{item.quote}</td>
                                            <td>
                                                {item?.author_image ? (
                                                    <a
                                                        href={item.author_image}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <i
                                                            className="fas fa-eye"
                                                            style={{ fontSize: "20px", cursor: "pointer" }}
                                                        ></i>
                                                    </a>
                                                ) : (
                                                    "N/A"
                                                )}
                                            </td>
                                            <td>
                                                <div 
                                                    className="text-center d-flex gap-3 justify-content-center"
                                                    style={{ flexWrap: "wrap", justifyContent: "center" }}
                                                >
                                                    <button
                                                        onClick={() => navigate(`${ADMINCMSTESTIMONIALUPDATE}/${item.id}`)}
                                                        className="edit"
                                                    >
                                                        <i className="fa-solid fa-info"></i>
                                                    </button>
                                                    <button
                                                        onClick={() => handleDelete(item.id)}
                                                        className="edit"
                                                    >
                                                        <i className="fa-solid fa-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>


                            {testimonialList.length > 0 == 0 && (
                                <h1 style={{ textAlign: "center" }}>No Testimonial Found</h1>
                            )}
                        </div>
                    </div>
                </section>
            </div>
            <ToastContainer />
        </>
    );
};
export default AdminTestimonialList;
